import React from 'react';
import { FaGavel, FaFileContract, FaExclamationTriangle, FaCheckCircle, FaTimesCircle } from 'react-icons/fa';

const TermsOfService = () => {
  const sections = [
    {
      id: 'overview',
      title: 'Terms of Service Overview',
      icon: <FaFileContract className="text-blue-500" />,
      content: `These Terms of Service ("Terms") govern your use of the Adira Logistics admin panel and related services. By accessing or using our services, you agree to be bound by these Terms. If you disagree with any part of these terms, you may not access our services.`
    },
    {
      id: 'definitions',
      title: 'Definitions',
      icon: <FaGavel className="text-green-500" />,
      content: `• "Service" refers to the Adira Logistics admin panel and related services
• "User," "you," and "your" refers to you as the user of the Service
• "Company," "we," "us," and "our" refers to Adira Logistics
• "Content" refers to text, images, or other information that can be posted, uploaded, linked to, or otherwise made available by Users
• "Account" means a unique account created for you to access our Service`
    },
    {
      id: 'acceptance',
      title: 'Acceptance of Terms',
      icon: <FaCheckCircle className="text-green-600" />,
      content: `By accessing and using this Service, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.`
    },
    {
      id: 'user-accounts',
      title: 'User Accounts',
      icon: <FaFileContract className="text-purple-500" />,
      content: `When you create an account with us, you must provide information that is accurate, complete, and current at all times. You are responsible for safeguarding the password and for all activities that occur under your account. You agree not to disclose your password to any third party and to take sole responsibility for any activities or actions under your account.`
    },
    {
      id: 'acceptable-use',
      title: 'Acceptable Use Policy',
      icon: <FaCheckCircle className="text-blue-600" />,
      content: `You may use our Service only for lawful purposes and in accordance with these Terms. You agree not to use the Service:

• In any way that violates any applicable federal, state, local, or international law or regulation
• To transmit, or procure the sending of, any advertising or promotional material
• To impersonate or attempt to impersonate the Company, a Company employee, another user, or any other person or entity
• To engage in any other conduct that restricts or inhibits anyone's use or enjoyment of the Service`
    },
    {
      id: 'prohibited-activities',
      title: 'Prohibited Activities',
      icon: <FaExclamationTriangle className="text-red-500" />,
      content: `You may not access or use the Service for any purpose other than that for which we make the Service available. The Service may not be used in connection with any commercial endeavors except those that are specifically endorsed or approved by us. Specifically, you agree not to:

• Use the Service in any manner that could disable, overburden, damage, or impair the site
• Use any robot, spider, or other automatic device, process, or means to access the Service
• Introduce any viruses, trojan horses, worms, logic bombs, or other material which is malicious or technologically harmful
• Attempt to gain unauthorized access to, interfere with, damage, or disrupt any parts of the Service`
    },
    {
      id: 'intellectual-property',
      title: 'Intellectual Property Rights',
      icon: <FaGavel className="text-indigo-500" />,
      content: `The Service and its original content, features, and functionality are and will remain the exclusive property of Adira Logistics and its licensors. The Service is protected by copyright, trademark, and other laws. Our trademarks and trade dress may not be used in connection with any product or service without our prior written consent.`
    },
    {
      id: 'user-content',
      title: 'User-Generated Content',
      icon: <FaFileContract className="text-teal-500" />,
      content: `By posting content to the Service, you grant us the right and license to use, modify, publicly perform, publicly display, reproduce, and distribute such content on and through the Service. You retain any and all of your rights to any content you submit, post, or display on or through the Service and you are responsible for protecting those rights.`
    },
    {
      id: 'privacy',
      title: 'Privacy Policy',
      icon: <FaCheckCircle className="text-green-500" />,
      content: `Your privacy is important to us. Please review our Privacy Policy, which also governs your use of the Service, to understand our practices.`
    },
    {
      id: 'termination',
      title: 'Termination',
      icon: <FaTimesCircle className="text-red-600" />,
      content: `We may terminate or suspend your account and bar access to the Service immediately, without prior notice or liability, under our sole discretion, for any reason whatsoever and without limitation, including but not limited to a breach of the Terms. If you wish to terminate your account, you may simply discontinue using the Service.`
    },
    {
      id: 'limitation-liability',
      title: 'Limitation of Liability',
      icon: <FaExclamationTriangle className="text-orange-500" />,
      content: `In no event shall Adira Logistics, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your use of the Service.`
    },
    {
      id: 'disclaimer',
      title: 'Disclaimer',
      icon: <FaExclamationTriangle className="text-yellow-500" />,
      content: `The information on this Service is provided on an "as is" basis. To the fullest extent permitted by law, this Company excludes all representations, warranties, conditions and terms whether express or implied.`
    },
    {
      id: 'governing-law',
      title: 'Governing Law',
      icon: <FaGavel className="text-blue-600" />,
      content: `These Terms shall be interpreted and governed by the laws of the jurisdiction in which Adira Logistics operates, without regard to its conflict of law provisions.`
    },
    {
      id: 'changes',
      title: 'Changes to Terms',
      icon: <FaFileContract className="text-green-600" />,
      content: `We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material, we will try to provide at least 30 days notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.`
    },
//     {
//       id: 'contact',
//       title: 'Contact Information',
//       icon: <FaCheckCircle className="text-blue-500" />,
//       content: `If you have any questions about these Terms of Service, please contact us:

// **Adira Logistics**
// Email: legal@adiralogistics.com
// Phone: +1-555-LEGAL
// Address: 123 Legal Street, Compliance City, CC 12345`
//     }
  ];

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-full mb-6">
            <FaGavel className="text-3xl text-blue-600" />
          </div>
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Terms of Service</h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Please read these terms carefully before using our services.
          </p>
          <div className="mt-4 text-sm text-gray-500">
            Last updated: {new Date().toLocaleDateString('en-US', { 
              year: 'numeric', 
              month: 'long', 
              day: 'numeric' 
            })}
          </div>
        </div>

        {/* Table of Contents */}
        <div className="bg-white rounded-lg shadow-sm border p-6 mb-8">
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">Table of Contents</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
            {sections.map((section, index) => (
              <a
                key={section.id}
                href={`#${section.id}`}
                className="text-blue-600 hover:text-blue-800 hover:underline flex items-center"
              >
                <span className="text-gray-500 mr-2">{index + 1}.</span>
                {section.title}
              </a>
            ))}
          </div>
        </div>

        {/* Terms Sections */}
        <div className="space-y-8">
          {sections.map((section, index) => (
            <div key={section.id} id={section.id} className="bg-white rounded-lg shadow-sm border p-8">
              <div className="flex items-center mb-6">
                <div className="mr-4">
                  {section.icon}
                </div>
                <h2 className="text-2xl font-semibold text-gray-900">{section.title}</h2>
              </div>
              
              <div className="prose prose-lg max-w-none">
                <div className="whitespace-pre-line text-gray-700 leading-relaxed">
                  {section.content}
                </div>
              </div>
              
              {index < sections.length - 1 && (
                <div className="mt-6 pt-6 border-t border-gray-200">
                  <a
                    href={`#${sections[index + 1].id}`}
                    className="inline-flex items-center text-blue-600 hover:text-blue-800 hover:underline"
                  >
                    Next: {sections[index + 1].title}
                    <svg className="ml-2 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </a>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="mt-12 text-center">
          <div className="bg-white rounded-lg shadow-sm border p-6">
            <p className="text-gray-600 mb-4">
              By using our services, you agree to these terms and conditions.
            </p>
            <p className="text-sm text-gray-500">
              These terms are effective as of the date shown above and apply to all users of our admin panel and related services.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;

